import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], disableClick, ...other }) {
  return (
    <Box {...other} style={{ width: '100%' }}>
      <List disablePadding sx={{ p: 1 }} >
        {data.map((item) => (
          <NavItem key={item.title} item={item} disableClick={disableClick} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item, disableClick }) {
  const { title, path, icon, info } = item;
  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
          width: '100%'
        },
        pointerEvents: disableClick ? "none" : "auto",
        opacity: disableClick ? 0.5 : 1
      }}

    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText className='hide-text-collaped-tab' disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
